export default function config(
  state = {
    name: 'TCBL',
    description: 'Organizing the Basketball League',
    url: 'https://tcblbasketball.com',
    layout: 'layout-1',
    collapsed: false,
    rightSidebar: false,
    backdrop: false,
    profilePic: '/images/faces/avatar.svg'
  },
  action
) {
  switch (action.type) {
    case 'SET_CONFIG':
      return {
        ...state,
        ...action.config
      }
    case 'SET_CONFIG_KEY':
      let {key, value} = {...action}
      return {
        ...state,
        [`${key}`]: value
      }
    default:
      return state
  }
}
